import { useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import useAccount from '../hooks/use-account';
import { AccountItemTypes } from '../types';
import AccountItemComponent from '../../../../components/common/accounts/item';
import {
  clearClosingBalances,
  clearSettingsPanel,
} from '../../store/slices/accounts';

const AccountItem = ({
  blockCreditIsSuccess,
  unblockCreditIsSuccess,
  blockDebitIsSuccess,
  unblockDebitIsSuccess,
  closeIsSuccess,
  openIsSuccess,
  account,
  overdraftEnabled,
  setBalances,
  setDefaultBalances,
  accountsBalances,
  balance,
  setShowCurrencies,
  setTopUpPanelIsOpen,
  setStatementPanelVisible,
  setSelectedAccount,
  setCurrenciesList,
  status: organizationStatus,
  updateVisibilityInProgress,
  updateOverdraftBalanceIsLoading,
  onUpdateVisibility,
  defaultBalances,
  onUpdateOverdraftBalanceValue,
  closedBalances,
  onBlockWithdraw,
  blockWithdrawInProgress,
  blockUblockWithdrawalsError,
  onBlockTopup,
  blockTopupInProgress,
  blockUblockTopupError,
  closeOpenError,
  closeInProgress,
  onClose,
  selectedAccount,
}: AccountItemTypes) => {
  const { customerId } = useParams();

  const { baseCurrency } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { accountsLogs, accountsLogsPagination } = useAppSelector(
    (state) => state.customersAccounts,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const {
    currenciesList: currencies,
    currencies: currenciesList,
    activePermissions,
    ffSettings,
  } = useAppSelector((state) => state.root);

  const dispatch = useAppDispatch();

  const {
    accountOverdraftEnabled,
    setSettingsPanelVisible,
    // setSelectedAccountId,
    settingsPanelVisible,
    setSelectedTab,
    setOverdraftEnabled,
    setClosingBalancesAt,
    selectedTab,
    creditBlock,
    setCreditBlock,
    setBlockTopupPopupVisible,
    debitBlock,
    setDebitBlock,
    setBlockWithdrawPopupVisible,
    visibleToClient,
    setVisibleToClient,
    closingBalancesAt,
    getCustomerAccountClosingBalancesAction,
    onUpdateOverdraftStatus,
    overdraftUpdateInProgress,
    balancesIsLoading,
    balancesIsFetching,
    closed,
    setClosePopupVisible,
    isLoading,
    isFetching,
    getChangeLogsAction,
    blockWithdrawPopupVisible,
    blockTopupPopupVisible,
    setComment,
    closePopupVisible,
    comment,
  } = useAccount({
    customerId,
    blockCreditIsSuccess,
    unblockCreditIsSuccess,
    blockDebitIsSuccess,
    unblockDebitIsSuccess,
    closeIsSuccess,
    openIsSuccess,
    account,
    overdraftEnabled,
    activePermissions,
    accountsLogs,
    setBalances,
    setDefaultBalances,
    accountsBalances,
    balance,
    selectedAccount,
  });

  return (
    <AccountItemComponent
      balance={balance}
      baseCurrency={baseCurrency}
      currencies={currencies}
      account={account}
      currenciesList={currenciesList}
      overdraftEnabled={overdraftEnabled}
      accountOverdraftEnabled={accountOverdraftEnabled}
      setShowCurrencies={setShowCurrencies}
      setTopUpPanelIsOpen={setTopUpPanelIsOpen}
      setStatementPanelVisible={setStatementPanelVisible}
      setSelectedAccount={setSelectedAccount}
      setCurrenciesList={setCurrenciesList}
      setSettingsPanelVisible={setSettingsPanelVisible}
      settingsPanelVisible={settingsPanelVisible}
      selectedAccount={selectedAccount}
      setSelectedTab={setSelectedTab}
      setOverdraftEnabled={setOverdraftEnabled}
      setBalances={setBalances}
      setDefaultBalances={setDefaultBalances}
      setClosingBalancesAt={setClosingBalancesAt}
      clearSettingsPanel={() => dispatch(clearSettingsPanel())}
      organizationStatus={organizationStatus}
      updateVisibilityInProgress={updateVisibilityInProgress}
      updateOverdraftBalanceIsLoading={updateOverdraftBalanceIsLoading}
      visibleToClient={visibleToClient}
      onUpdateVisibility={onUpdateVisibility}
      defaultBalances={defaultBalances}
      accountsBalances={accountsBalances}
      onUpdateOverdraftBalanceValue={onUpdateOverdraftBalanceValue}
      selectedTab={selectedTab}
      creditBlock={creditBlock}
      setCreditBlock={setCreditBlock}
      setBlockTopupPopupVisible={setBlockTopupPopupVisible}
      debitBlock={debitBlock}
      setDebitBlock={setDebitBlock}
      setBlockWithdrawPopupVisible={setBlockWithdrawPopupVisible}
      setVisibleToClient={setVisibleToClient}
      closingBalancesAt={closingBalancesAt}
      getCustomerAccountClosingBalancesAction={
        getCustomerAccountClosingBalancesAction
      }
      clearClosingBalances={() => dispatch(clearClosingBalances())}
      closedBalances={closedBalances}
      onUpdateOverdraftStatus={onUpdateOverdraftStatus}
      overdraftUpdateInProgress={overdraftUpdateInProgress}
      balancesIsLoading={balancesIsLoading}
      balancesIsFetching={balancesIsFetching}
      closed={closed}
      setClosePopupVisible={setClosePopupVisible}
      activePermissions={activePermissions}
      isLoading={isLoading}
      accountsLogs={accountsLogs}
      users={users}
      accountsLogsPagination={accountsLogsPagination}
      isFetching={isFetching}
      getChangeLogsAction={getChangeLogsAction}
      onBlockWithdraw={onBlockWithdraw}
      blockWithdrawInProgress={blockWithdrawInProgress}
      blockWithdrawPopupVisible={blockWithdrawPopupVisible}
      blockUblockWithdrawalsError={blockUblockWithdrawalsError}
      onBlockTopup={onBlockTopup}
      blockTopupInProgress={blockTopupInProgress}
      blockTopupPopupVisible={blockTopupPopupVisible}
      blockUblockTopupError={blockUblockTopupError}
      setComment={setComment}
      closePopupVisible={closePopupVisible}
      comment={comment}
      closeOpenError={closeOpenError}
      closeInProgress={closeInProgress}
      onClose={onClose}
      ffSettings={ffSettings}
    />
  );
};

export default AccountItem;
